<!-- Inner Banner Start-->
<section class="inner-hero-banner">
  <div class="inner-hero-text" *ngIf="auth.user$ | async as user">
    <h1>{{ user.displayName }}</h1>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#" i18n>Home</a></li>
        <li class="breadcrumb-item active" aria-current="page" i18n>Workspace</li>
      </ol>
    </nav>
  </div>
</section>

          <!-- Line Animations Effect-->
          <div class="lines">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          
<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-12">
        <div class="blog-single">
          <div class="card blog--card">
            <label class="input-field col s12">Logo <br><input type="file" id="file" #logo
                (change)="onLogoSelected($event)" name="image" autocomplete="off" />
            </label>
            <label class="input-field col s12">
              Description Image <br>
              <input type="file" id="file" #descriptionImg (change)="onDescriptionImgSelected($event)" name="image"
                autocomplete="off" />
            </label>
            <form [formGroup]="this.dataService.form" (ngSubmit)="onSubmit()">
              <input placeholder="Name" formControlName="Name" type="text" class="input-field col s12">
              <input placeholder="Category" formControlName="Category" type="text" class="input-field col s12">
              <input placeholder="Description" formControlName="Description" type="text" class="input-field col s12">
              <input placeholder="Address" formControlName="Address" type="text" class="input-field col s12">
            </form>
            <input placeholder="Total Capacity" type="number" (change)="onTrafficAdded($event)"
              class="input-field col s12" autocomplete="off" #totalCapacity />
            <button class=" btn btn-sm theme-btn text-white text-uppercase send-btn waves-effect waves-light btn col s12" (click)="onSubmit()">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-md-8 col-12">
        <div class="blog-single">
          <div class="card blog--card">
            <figure>
              <a href=""><img src="assets/images/blog/1.jpg" class="img-fluid" alt=""></a>
              <figcaption>
                <a href=""><i class="mdi mdi-image-outline"></i></a>
              </figcaption>
            </figure>
            <div class="card-body">
              <h5><a href="">dolor sit amet, consectetur adipisicing elit,</a></h5>
              <ul class="post-meta d-flex">
                <li>Mar 12, 2020</li>
                <li>by <a href="">Tomillo</a></li>
                <li>in <a href="">Event</a></li>
                <li><a href="">6 Comments</a></li>
              </ul>
              <p class="m-0">is simply dummy text of the printing and typesetting industry. has been the industry's
                standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it
                to make a type specimen book. </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</section>
<!-- End Blog Area -->